import { get as _get, map as _map, forEach as _forEach, isUndefined as _isUndefined,
first as _first, keys as _keys, values as _values, isEmpty as _isEmpty, camelCase as _camelCase, trimStart as _trimStart } from "lodash-es";
import { startWith, tap } from "rxjs/operators";
import { StudioFormConfig } from "../models/inputElementTypes.model";

export const getUuid = () => {
    // http://www.ietf.org/rfc/rfc4122.txt
    var s: any = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
}

export const getFieldArrayprops = () => {
    return {
        "min": 1,
        "addText": 'Add row',
      }
}


export const fieldArrayConfig = (defaultKey?, defaultValue?, expressions?, labelForKey?, labelForValue?) => {
    return {
        "fieldGroupClassName": 'd-flex flex-gap-half',
        "fieldGroup": [
          {
            "type": 'input',
            "key": 'key',
            ...(defaultKey && {defaultValue: defaultKey}),
            "props": {
              "label": labelForKey || 'key',
      			  "required": true,
              "placeholder": 'Enter key',
              appearance: 'outline'
            },
            expressions: {...expressions}
          },
          {
            "type": 'input',
            "key": 'value',
            ...(defaultValue && {defaultValue: defaultValue}),
            "props": {
              "label": labelForValue || 'value',
      			  "required": true,
              "placeholder": 'Enter value',
              appearance: 'outline'
            },
            expressions: {...expressions}
          },
        ],
      }
}

export const possibleChildProperty: string[]= ['child', 'dimensionEnumeratorChildren', 'entityExtractionChainChild', 'paginationControllerChild', 'paginationMetadataChainChild', 'authenticationControllerChild', 'authenticationControllerChildren', 'constituentApiChildren', 'gcsCacheEntityTransformationOpsChild', 'backupEntitySourceChild'];


export const generateFieldGroup = (data) => {
	return _map(data, (value, key) => {
		return {
			"key": key,
			"type": "keyValue",
			"className": "form-params-field",
			"props": {
				"label": key,
				...getFieldArrayprops()
			},
			// ...(!_isUndefined(value) ? {"fieldArray": fieldArrayConfig(_first(_keys(value)), _first(_values(value)) )} : {"fieldArray": fieldArrayConfig()}),
      "fieldArray": fieldArrayConfig(),
			"validations": [{
				"required": false
			}]
		}
	})
}

/**
** 
Format
------ 
{
    "FROM_NODE": {
        "TO_NODE" : "ATTACHMENT_TYPE"
    }
}
**
**/



export const attachmentTypeMap = {
    'ENTITY_PROCESSOR_NODE': {
        'API_ENTITY_SOURCE_NODE': 'ENTITY_PROCESSOR_ATTACHMENT',
        'GCS_CACHE_ENTITY_SOURCE_NODE': 'ENTITY_PROCESSOR_ATTACHMENT',
        'PREDEFINED_ENTITIES_ENTITY_SOURCE_NODE': 'ENTITY_PROCESSOR_ATTACHMENT',
        'REPORT_ENTITY_SOURCE_NODE': 'ENTITY_PROCESSOR_ATTACHMENT',
        'DATE_ENTITY_SOURCE_NODE': 'ENTITY_PROCESSOR_ATTACHMENT',
        'DATETIME_ENTITY_SOURCE_NODE': 'ENTITY_PROCESSOR_ATTACHMENT',
        'TIMESTAMP_ENTITY_SOURCE_NODE': 'ENTITY_PROCESSOR_ATTACHMENT',
        'WEEK_ENTITY_SOURCE_NODE': 'ENTITY_PROCESSOR_ATTACHMENT'
    },
    'API_ENTITY_SOURCE_NODE': {
        'PARENT_DIMENSION_ENUMERATOR_NODE': 'DIMENSION_ENUMERATOR_ATTACHMENT',
        'RANGE_DIMENSION_ENUMERATOR_NODE': 'DIMENSION_ENUMERATOR_ATTACHMENT',
        'ENTITY_EXTRACTION_CHAIN_NODE': 'ENTITY_EXTRACTION_CHAIN_ATTACHMENT',
        'PAGINATION_METADATA_CHAIN_NODE': 'PAGINATION_METADATA_CHAIN_ATTACHMENT',
        'NONE_PAGINATION_CONTROLLER_NODE': 'PAGINATION_CONTROLLER_ATTACHMENT',
        'PAGE_BASED_PAGINATION_CONTROLLER_NODE': 'PAGINATION_CONTROLLER_ATTACHMENT',
        'OFFSET_BASED_PAGINATION_CONTROLLER_NODE': 'PAGINATION_CONTROLLER_ATTACHMENT',
        'CURSOR_BASED_PAGINATION_CONTROLLER_NODE': 'PAGINATION_CONTROLLER_ATTACHMENT',
        'NONE_AUTHENTICATION_CONTROLLER_NODE': 'AUTHENTICATION_CONTROLLER_ATTACHMENT',
        'STATIC_AUTHENTICATION_CONTROLLER_NODE': 'AUTHENTICATION_CONTROLLER_ATTACHMENT',
        'TWO_STEP_AUTHENTICATION_CONTROLLER_NODE': 'AUTHENTICATION_CONTROLLER_ATTACHMENT'
    },
    'GCS_CACHE_ENTITY_SOURCE_NODE': {
        'API_ENTITY_SOURCE_NODE': 'BACKUP_ENTITY_SOURCE_ATTACHMENT',
        'GCS_CACHE_ENTITY_SOURCE_NODE': 'BACKUP_ENTITY_SOURCE_ATTACHMENT',
        'PREDEFINED_ENTITIES_ENTITY_SOURCE_NODE': 'BACKUP_ENTITY_SOURCE_ATTACHMENT',
        'REPORT_ENTITY_SOURCE_NODE': 'BACKUP_ENTITY_SOURCE_ATTACHMENT',
        'DATE_ENTITY_SOURCE_NODE': 'BACKUP_ENTITY_SOURCE_ATTACHMENT',
        'DATETIME_ENTITY_SOURCE_NODE': 'BACKUP_ENTITY_SOURCE_ATTACHMENT',
        'TIMESTAMP_ENTITY_SOURCE_NODE': 'BACKUP_ENTITY_SOURCE_ATTACHMENT',
        'WEEK_ENTITY_SOURCE_NODE': 'BACKUP_ENTITY_SOURCE_ATTACHMENT',
        'GCS_CACHE_ENTITY_TRANSFORMATION_OPS_NODE': 'GCS_CACHE_ENTITY_TRANSFORMATION_OPS_ATTACHMENT'
    },
    'PARENT_DIMENSION_ENUMERATOR_NODE': {
        'API_ENTITY_SOURCE_NODE': 'PARENT_DIMENSION_BACKING_ENTITY_SOURCE_ATTACHMENT',
        'REPORT_ENTITY_SOURCE_NODE': 'PARENT_DIMENSION_BACKING_ENTITY_SOURCE_ATTACHMENT',
        'GCS_CACHE_ENTITY_SOURCE_NODE': 'PARENT_DIMENSION_BACKING_ENTITY_SOURCE_ATTACHMENT',
        'PREDEFINED_ENTITIES_ENTITY_SOURCE_NODE': 'PARENT_DIMENSION_BACKING_ENTITY_SOURCE_ATTACHMENT',
        'DATE_ENTITY_SOURCE_NODE': 'PARENT_DIMENSION_BACKING_ENTITY_SOURCE_ATTACHMENT',
        'DATETIME_ENTITY_SOURCE_NODE': 'PARENT_DIMENSION_BACKING_ENTITY_SOURCE_ATTACHMENT',
        'TIMESTAMP_ENTITY_SOURCE_NODE': 'PARENT_DIMENSION_BACKING_ENTITY_SOURCE_ATTACHMENT',
        'WEEK_ENTITY_SOURCE_NODE': 'PARENT_DIMENSION_BACKING_ENTITY_SOURCE_ATTACHMENT'
    },
    'RANGE_DIMENSION_ENUMERATOR_NODE': {
        'DATE_ENTITY_SOURCE_NODE': 'RANGE_DIMENSION_BACKING_ENTITY_SOURCE_ATTACHMENT',
        'DATETIME_ENTITY_SOURCE_NODE': 'RANGE_DIMENSION_BACKING_ENTITY_SOURCE_ATTACHMENT',
        'TIMESTAMP_ENTITY_SOURCE_NODE': 'RANGE_DIMENSION_BACKING_ENTITY_SOURCE_ATTACHMENT',
        'WEEK_ENTITY_SOURCE_NODE': 'RANGE_DIMENSION_BACKING_ENTITY_SOURCE_ATTACHMENT'
    },
    'REPORT_ENTITY_SOURCE_NODE': {
      'CONSTITUENT_API_NODE': 'CONSTITUENT_API_ATTACHMENT',
      'NONE_AUTHENTICATION_CONTROLLER_NODE': 'AUTHENTICATION_CONTROLLER_ATTACHMENT',
      'STATIC_AUTHENTICATION_CONTROLLER_NODE': 'AUTHENTICATION_CONTROLLER_ATTACHMENT',
      'TWO_STEP_AUTHENTICATION_CONTROLLER_NODE': 'AUTHENTICATION_CONTROLLER_ATTACHMENT',
      'PARENT_DIMENSION_ENUMERATOR_NODE': 'DIMENSION_ENUMERATOR_ATTACHMENT',
      'RANGE_DIMENSION_ENUMERATOR_NODE': 'DIMENSION_ENUMERATOR_ATTACHMENT'
    }
}

export const getAttachmentType = (fromNode, toNode) => {
    return _get(attachmentTypeMap, `${fromNode}.${toNode}`)
}


/*!
 * Add items to an object at a specific path
 * (c) 2021 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Object}       obj  The object
 * @param  {String|Array} path The path to assign the value to
 * @param  {*}            val  The value to assign
 */
export const put = (obj, path, val)  => {

	/**
	 * If the path is a string, convert it to an array
	 * @param  {String|Array} path The path
	 * @return {Array}             The path array
	 */
	function stringToPath (path) {

		// If the path isn't a string, return it
		if (typeof path !== 'string') return path;

		// Create new array
		let output = [];
    //removing $. from the start of the path
    path = _trimStart(path, '$.');
		// Split to an array with dot notation
		path.split('.').forEach(function (item) {

			// Split to an array with bracket notation
			item.split(/\[([^}]+)\]/g).forEach(function (key) {

				// Push to the new array
				if (key.length > 0) {
					output.push(key);
				}

			});

		});

		return output;

	}

	// Convert the path to an array if not already
	path = stringToPath(path);

	// Cache the path length and current spot in the object
	let length = path.length;
	let current = obj;

	// Loop through the path
	path.forEach(function (key, index) {

		// Check if the assigned key should be an array
		let isArray = key.slice(-2) === '[]';

		// If so, get the true key name by removing the trailing []
		key = isArray ? key.slice(0, -2) : key;

		// If the key should be an array and isn't, create an array
		if (isArray && !Array.isArray(current[key])) {
			current[key] = [];
		}

		// If this is the last item in the loop, assign the value
		if (index === length -1) {

			// If it's an array, push the value
			// Otherwise, assign it
			if (isArray) {
				current[key].push(val);
			} else {
				current[key] = val;
			}
		}

		// Otherwise, update the current place in the object
		else {

			// If the key doesn't exist, create it
			if (!current[key]) {
				current[key] = {};
			}

			// Update the current place in the object
			current = current[key];

		}

	});

}


export const modifyTopLevelParamsBeforeSending = (controls, fields?, type?) => {
    let modifiedFields = {}

    switch (type) {
      case 'nestedKeyValue':
        let modifiedNestedFields = {}
        _forEach(fields, (field, key) => {
          const nestedKeyValueParams = _get(controls.get(field.key), 'value');
          _forEach(nestedKeyValueParams, (param, key) => {
            modifiedNestedFields[key] = modifyKeyValueField(param)
          })
          modifiedFields[field.key] = modifiedNestedFields
        })
      break;
    }
    return modifiedFields
  }

export const modifyKeyValueField = (fieldValue) => {
	const keyValueMap = {}
	_forEach(fieldValue, value => {
		keyValueMap[value.key] = value['value']
	});
	return keyValueMap
}

export const reModifyKeyValueField = (value, key) => {
	return _map(value, (v, k) => {
		return {key: k, value: v}
	})
}


export const reModifyNestedKeyValueField = (values) => {
  let modifiedKey = {}
  _forEach(values, (value, key) => {
    modifiedKey[key] = reModifyKeyValueField(value, key)
  })
  return modifiedKey
}

export const variablePoolPathHook = (field, type?) => {
    return field.form.get('id').valueChanges.pipe(
      startWith(field.form.get('id').value),
      tap((value) => {
          if(_isUndefined(value)) {
              return
          } else if(_isEmpty(value)) {
              field.formControl.setValue('')
          } else {
            if(!field.formControl.defaultValue) {
              if(type) {
                field.formControl.setValue(`$.${value}_${type}`)
              } else {
                field.formControl.setValue(`$.${value}`)
              }
            }
          }
      })
  )
}

export const idFieldsHook = (field) => {
  return field.form.get('label').valueChanges.pipe(
    startWith(field.form.get('label').value),
    tap((value: any) => {
        if(_isUndefined(value)) {
            return
        } else if(_isEmpty(value)) {
            field.formControl.setValue('')
        } else if(!field.formControl.defaultValue) {
          field.formControl.setValue(`${_camelCase(value)}`)
        }
    })
  )
}